import { OrderStatus } from '@/api-sdk';
import { SelectOption } from '@/types';

export const dataPrintProofStatus: SelectOption[] = [
  {
    value: 'all',
    text: 'labels.all',
  },
  {
    value: OrderStatus.FULFILLED,
    text: 'content.printProof.statusOrderFulfilled',
  },
  {
    value: OrderStatus.PENDING,
    text: 'content.printProof.statusOrderPending',
  },
  {
    value: OrderStatus.PRINT_PROOF_REVIEW,
    text: 'content.printProof.statusOrderReview',
  },
];
